import { FilterRowProps } from "../../../components/UtilitiesComponent/FilterRow";
import assest from "../../../json/assest";
//   import Image from "next/image";
import React from "react";
import styles from "../../../styles/pages/home.module.scss";
import {
  Box,
  Button,
  Dialog,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Pagination from "../../../components/UtilitiesComponent/Pagination";
import AllPurchasedFilterModal from "../../../components/FilterModal/AllPurchasedFilterModal";
//   import { useRouter } from "next/router";
import DisplayRelease from "../../../components/DisplayRelease/DisplayRelease";
import styles1 from "../../../styles/components/PartnerPageTable/PartnerAllTable.module.scss";
import PartnerDuplicateFilter from "../../../components/AllFilterRow/PartnerPageFilter/PartnerDuplicateFilter";
import { useNavigate } from "react-router";
import {
  getAbsoluteImageURI,
  getStyledDateTime,
  isFirstCalenderSelection,
} from "../../../lib/functions/utils.lib";
import NoResult from "../../NoResult/NoResult";
import partnerDuplicateFilterModal from "../../FilterModal/partnerDuplicateFilterModal";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { Link } from "react-router-dom";
import EmptyTable from "../../EmptyTable/EmptyTable";
import Filter from "../../Filter/Filter";
import VideoPageFullModal from "../../VideoPages/pages/VideoPageFullModal";
import WatchVideoModal from "../../VideoPages/pages/WatchVideoModal";

export default function PartnerDuplicateTable(props) {
  const { hideApprovedTab, approvedTabName, filterRowProps } = props;
  const route = useNavigate();

  // for modal

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (value) => {
    setOpen(false);
  };

  // for modal
  const [openModal, setOpenModal] = React.useState(false);
  const [openModalTwo, setOpenModalTwo] = React.useState(false);
  const [id, setId] = React.useState();

  const onOpen = (id) => {
    setId(id);
    setOpenModal(true);
  };
  const onClose = () => {
    setId();
    setOpenModal(false);
    // handleTriggreFetch();
  };
  const onOpenTwo = (id) => {
    setId(id);
    setOpenModalTwo(true);
  };
  const onCloseTwo = () => {
    setId();
    setOpenModalTwo(false);
  };

  return (
    <Box className={`${styles.table_sec} ${styles1.tableSecPartner}`}>
      <Box className={styles.table_top}>
        <PartnerDuplicateFilter
          {...filterRowProps}
          FilterModalComponent={partnerDuplicateFilterModal}
          filterModalProps={{
            hideBottom: true,
            modalFields: props?.modalFields,
            handleFilter: props?.handleFilter,
            resetFilterparams: props?.resetFilterparams,
          }}
          handleSearchStringChange={props?.handleSearchStringChange}
          handleDateChange={props?.handleDateChange}
        />
      </Box>

      <Box
        className={`${styles.table_main} ${styles1.tableDuplicate} ${styles1.tableApproveTabs}`}
      >
        {/* <PerfectScrollbar> */}
        <TableContainer component={Paper}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell className={styles1.vsid}>VSID</TableCell>
                <TableCell className={styles1.thumnail}>Thumbnail</TableCell>
                <TableCell className={styles1.tableTitle}>Title</TableCell>
                <TableCell className={styles1.submitter}>
                  Submitter Name
                </TableCell>
                <TableCell className={styles1.email}>Email Address</TableCell>
                <TableCell className={styles1.submission}>
                  Submission Date
                </TableCell>
                <TableCell className={styles1.rejected}>Flagged by</TableCell>
                <TableCell className={styles1.view}>View</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {props?.videos?.data?.length &&
                isFirstCalenderSelection(props?.submissionsDate) ? (
                props?.videos?.data?.map((row, index) => (
                  <>
                    <TableRow
                      key={index}
                      sx={{
                        "&:last-child td, &:last-child th": {
                          border: 0,
                        },
                      }}
                    >
                      <TableCell>
                        <Box className={styles.vsid_code}>
                          <img
                            src={assest.infoicon}
                            width={3}
                            height={18}
                            alt=""
                          />{" "}
                          <p>
                            {row?.id} <span className={styles.vsid_circ}></span>
                          </p>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box className={styles1.partnerImage}>
                          <figure
                            className={styles.thumb_img}
                            onClick={() => onOpenTwo(row?.id)}
                          >
                            <img
                              src={getAbsoluteImageURI(row?.thumbnail)}
                              width={73}
                              height={46}
                              alt="image"
                              className={styles.thumImg}
                            />
                          </figure>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <p className={styles.titleBox}>{row.title}</p>
                      </TableCell>
                      <TableCell>
                        <Box className={styles.submitterName}>
                          {row?.first_name || row?.last_name
                            ? `${row?.first_name} ${row?.last_name}`
                            : "N/A"}
                        </Box>
                      </TableCell>
                      <TableCell>{row?.email}</TableCell>
                      <TableCell>
                        {getStyledDateTime(row?.created_at)}
                      </TableCell>
                      <TableCell>
                        <Box className={styles.manager}>
                          {/* duplicate data */}
                          {row?.admin_decision ? (
                            "Me, Myself & I"
                          ) : row?.quality_team_decision ? (
                            <>
                              {`${row?.quality_team?.name
                                  ? row?.quality_team?.name
                                  : ""
                                } ${row?.quality_team?.last_name
                                  ? row?.quality_team?.last_name
                                  : ""
                                }`}
                              <span>QC Agent</span>
                            </>
                          ) : row?.manager_decision ? (
                            <>
                              {`${row?.manager?.name ? row?.manager?.name : ""
                                } ${row?.manager?.last_name
                                  ? row?.manager?.last_name
                                  : ""
                                }`}
                              <span>Manager</span>
                            </>
                          ) : (
                            <span className={styles.awaitingBtn}>
                              Awaiting Confirmation
                            </span>
                          )}
                          {/* duplicate data */}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box className={styles.table_view}>
                          <Button onClick={() => onOpen(row?.id)}>
                            <img
                              src={assest.tableview}
                              width={16}
                              height={16}
                              alt=""
                            />
                          </Button>
                        </Box>
                      </TableCell>
                    </TableRow>

                    <TableRow key={row.id} className={styles.blnkTd}>
                      <TableCell colSpan={8}>{""}</TableCell>
                    </TableRow>
                  </>
                ))
              ) : props?.modalFields !== null ? (
                <TableRow
                  sx={{
                    "&:last-child td, &:last-child th": {
                      border: 0,
                    },
                  }}
                  className={styles.paginationTble}
                >
                  <TableCell colSpan={10} className={styles1.filterparamswraps}>
                    <Filter resetFilters={props?.resetFilterparams} />
                  </TableCell>
                </TableRow>
              ) : props?.searchString?.length ? (
                <TableRow
                  sx={{
                    "&:last-child td, &:last-child th": {
                      border: 0,
                    },
                  }}
                  className={styles.paginationTble}
                >
                  <TableCell
                    colSpan={10}
                    className={`${styles1.withoutBorder} ${styles1.withoutBorderfilters}`}
                  >
                    <NoResult />
                  </TableCell>
                </TableRow>
              ) : (
                <TableRow
                  sx={{
                    "&:last-child td, &:last-child th": {
                      border: 0,
                    },
                  }}
                  className={styles.paginationTble}
                >
                  <TableCell colSpan={10} className={styles1.emptytable_reload}>
                    <EmptyTable
                      emptyTableText={
                        "You have no duplicated videos at the moment. Please reload the page or check back later."
                      }
                    />
                  </TableCell>
                </TableRow>
              )}

              <TableRow className={styles.paginationTble}>
                <TableCell colSpan={8} sx={{ border: "none !important" }}>
                  {props?.videos?.data?.length &&
                    isFirstCalenderSelection(props?.submissionsDate) ? (
                    <Pagination
                      page={props?.videos?.current_page}
                      lastpage={props?.videos?.last_page}
                      onClick={props?.handlePaginationPageChange}
                      sendDataToParent={props?.handlePaginationPageChange}
                    />
                  ) : (
                    ""
                  )}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        {/* </PerfectScrollbar> */}
      </Box>

      <Dialog className="filterModal" onClose={handleClose} open={open}>
        <DisplayRelease />
      </Dialog>
      <VideoPageFullModal
        onClose={onClose}
        open={openModal}
        id={id}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="videoPageModal"
      />
      <WatchVideoModal
        onClose={onCloseTwo}
        open={openModalTwo}
        id={id}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="videoPageModal"
      />
    </Box>
  );
}
